// src/store/assetSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const apiUrl = process.env.REACT_APP_API_URL;
// Async thunk to add a new asset
export const addAsset = createAsyncThunk(
    'assets/addAsset',
    async (assetData) => {
        const response = await fetch(`${apiUrl}/api/assets`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(assetData),
        });
        if (!response.ok) {
            throw new Error('Failed to save asset');
        }
        const data = await response.json();
        return data;
    }
);

// Async thunk for fetching assets
export const fetchAssets = createAsyncThunk(
    'asset/fetchAssets',
    async (_, { getState }) => {
        const { clientId, financialYear } = getState().app;
        const response = await fetch(`${apiUrl}/api/assets?clientId=${clientId}&financialYear=${financialYear}`);
        return response.json();
    }
);

// Async thunk for updating an asset
export const updateAsset = createAsyncThunk(
    'asset/updateAsset',
    async ({ id, asset }) => {
        const response = await fetch(`${apiUrl}/api/assets/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(asset),
        });
        return response.json();
    }
);

// Async thunk for deleting an asset
export const deleteAsset = createAsyncThunk(
    'asset/deleteAsset',
    async (id) => {
        await fetch(`${apiUrl}/api/assets/${id}`, {
            method: 'DELETE',
        });
        return id;
    }
);

const assetSlice = createSlice({
    name: 'asset',
    initialState: {
        assets: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Define any synchronous reducers here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAssets.fulfilled, (state, action) => {
                state.assets = action.payload;
                state.loading = false;
            })
            .addCase(fetchAssets.rejected, (state, action) => {
                state.error = action.error.message;
                state.loading = false;
            })
            .addCase(updateAsset.fulfilled, (state, action) => {
                const updatedAsset = action.payload;
                const index = state.assets.findIndex(asset => asset.id === updatedAsset.id);
                if (index !== -1) {
                    state.assets[index] = updatedAsset;
                }
            })
            .addCase(deleteAsset.fulfilled, (state, action) => {
                state.assets = state.assets.filter(asset => asset.id !== action.payload);
            })
            .addCase(addAsset.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAsset.fulfilled, (state, action) => {
                state.loading = false;
                state.assets.push(action.payload);
            })
            .addCase(addAsset.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default assetSlice.reducer;
